import script from "./SimpleImageSwiper.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleImageSwiper.vue?vue&type=script&setup=true&lang=js"

import "./SimpleImageSwiper.vue?vue&type=style&index=0&id=41711310&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41711310"]])

export default __exports__